import React from 'react';
import MultipleChoicesGrid from "../common/MultipleChoicesGrid";

const MultipleChoiceGrid = (props:any) => {
  return <MultipleChoicesGrid {...props} />
}

export default MultipleChoiceGrid;
